import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useNavigate } from 'react-router';
import { useTerminalClient } from '../client-rpc-router';
import { TerminalListRow } from '../components/TerminalListRow';
import { TerminalScreen } from '../components/TerminalScreen';

export default function InboundPage() {
	const client = useTerminalClient();

	const { data: documentTypes } = useQuery({
		queryKey: ['inbound-document-types'],
		queryFn: () => client.inboundDeliveryOrderProcess.inboundDeliveryOrderDocumentTypeGetAllForMeQuery.execute({})
	});

	return (
		<TerminalScreen showBackButton topBar={<div>Fronty příjmu</div>}>
			<div className="flex flex-col gap-2">
				{documentTypes?.map(documentType => <InboundDocumentTypeRow key={documentType.id} label={documentType.name} id={documentType.id} />)}
			</div>
		</TerminalScreen>
	);
}

const InboundDocumentTypeRow = React.memo(({ label, id }: { label: string; id: number }) => {
	const navigate = useNavigate();
	const client = useTerminalClient();

	const { data: count, isLoading } = useQuery({
		queryKey: ['inbound-document-type-count', id],
		queryFn: () => client.inboundDeliveryOrderProcess.countInboundDeliveryOrdersByDocumentTypeQuery.execute({ documentTypeId: id })
	});

	const goToDocumentType = () => {
		navigate(`/inbound/${id}/queues`);
	};

	return <TerminalListRow label={label} count={count} isLoading={isLoading} onClick={goToDocumentType} />;
});
